<template>
  <div class="auth-page">
    <div class="auth-layout">
      <div class="visual-panel">
      </div>

      <section class="form-card">
        <div class="content">
          <div class="card-header">
            <!-- <span>欢迎回来</span> -->
            <h1>用户登录</h1>
            <!-- <p>所有表单元素均按一行一个元素、自上而下布局。</p> -->
          </div>

          <el-tabs v-model="loginMode" class="login-mode-tabs">
            <el-tab-pane label="短信登录" name="sms" />
            <el-tab-pane label="密码登录" name="password" />
          </el-tabs>

          <el-form
            v-if="loginMode === 'sms'"
            ref="smsFormRef"
            :model="smsForm"
            :rules="smsRules"
            label-position="top"
            class="auth-form"
          >
            <el-form-item label="手机号" prop="phone">
              <el-input v-model="smsForm.phone" placeholder="请输入手机号" />
            </el-form-item>

            <el-form-item label="短信验证码" prop="smsCode">
              <el-input v-model="smsForm.smsCode" placeholder="请输入短信验证码">
                <template #suffix>
                  <button
                    type="button"
                    class="text-action"
                    :disabled="smsCountdown > 0"
                    @click="handleSendSmsCode"
                  >
                    {{ smsCountdown > 0 ? `已发送短信 ${smsCountdown}s` : '获取验证码' }}
                  </button>
                </template>
              </el-input>
            </el-form-item>

            <el-form-item label="图片验证码" prop="imageCode">
              <div class="captcha-field">
                <el-input v-model="smsForm.imageCode" placeholder="请输入图片验证码" />
                <button
                  type="button"
                  class="captcha-box"
                  @click="refreshCaptcha"
                >
                  <span>{{ captchaText }}</span>
                </button>
              </div>
            </el-form-item>

            <el-form-item>
              <el-button class="submit-btn" type="primary" @click="handleSmsLogin">登录</el-button>
            </el-form-item>
          </el-form>

          <el-form
            v-else
            ref="passwordFormRef"
            :model="passwordForm"
            :rules="passwordRules"
            label-position="top"
            class="auth-form"
          >
            <el-form-item label="账号" prop="username">
              <el-input v-model="passwordForm.username" placeholder="请输入账号" />
            </el-form-item>

            <el-form-item label="密码" prop="password">
              <el-input
                v-model="passwordForm.password"
                type="password"
                show-password
                placeholder="请输入密码"
              />
            </el-form-item>

            <el-form-item label="图片验证码" prop="imageCode">
              <div class="captcha-field">
                <el-input v-model="passwordForm.imageCode" placeholder="请输入图片验证码" />
                <button
                  type="button"
                  class="captcha-box"
                  @click="refreshCaptcha"
                >
                  <span>{{ captchaText }}</span>
                </button>
              </div>
            </el-form-item>

            <el-form-item>
              <el-button class="submit-btn" type="primary" @click="handlePasswordLogin">登录</el-button>
            </el-form-item>
          </el-form>

          <div class="switch-action">
            还没有账号？
            <button type="button" @click="goRegister">前往注册</button>
          </div>
        </div>
      </section>
    </div>

    <ContactDialog v-model="dialogVisible" />
  </div>
</template>

<script setup>
import { onBeforeUnmount, reactive, ref } from 'vue'
import { ElMessage } from 'element-plus'
import { useRouter } from 'vue-router'
import AuthVisualPanel from '@/components/AuthVisualPanel.vue'
import ContactDialog from '@/components/ContactDialog.vue'
import {
  isAdminAccount,
  isFixedImageCode,
  isFixedSmsCode,
  isPhone
} from '@/utils/validators'

const router = useRouter()
const loginMode = ref('sms')
const dialogVisible = ref(false)
const smsFormRef = ref()
const passwordFormRef = ref()
const smsCountdown = ref(0)
let smsTimer = null

const smsForm = reactive({
  phone: '',
  smsCode: '',
  imageCode: ''
})

const passwordForm = reactive({
  username: '',
  password: '',
  imageCode: ''
})

const smsRules = {
  phone: [
    { required: true, message: '请输入手机号', trigger: 'blur' },
    {
      validator: (_, value, callback) => {
        if (!isPhone(value)) {
          callback(new Error('请输入正确的手机号格式'))
          return
        }
        callback()
      },
      trigger: 'blur'
    }
  ],
  smsCode: [
    { required: true, message: '请输入短信验证码', trigger: 'blur' },
    {
      validator: (_, value, callback) => {
        if (!isFixedSmsCode(value)) {
          callback(new Error('短信验证码固定为 123456'))
          return
        }
        callback()
      },
      trigger: 'blur'
    }
  ],
  imageCode: [
    { required: true, message: '请输入图片验证码', trigger: 'blur' },
    {
      validator: (_, value, callback) => {
        if (!isFixedImageCode(value)) {
          callback(new Error('图片验证码固定为 ascyaf'))
          return
        }
        callback()
      },
      trigger: 'blur'
    }
  ]
}

const passwordRules = {
  username: [{ required: true, message: '请输入账号', trigger: 'blur' }],
  password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
  imageCode: smsRules.imageCode
}

const captchaText = ref('ASCYAF')

function handleSendSmsCode() {
  if (smsCountdown.value > 0) {
    return
  }

  if (!isPhone(smsForm.phone)) {
    ElMessage.warning('请先输入正确的手机号')
    return
  }

  ElMessage.success('短信已发送')
  smsCountdown.value = 60

  smsTimer = window.setInterval(() => {
    smsCountdown.value -= 1

    if (smsCountdown.value <= 0) {
      clearSmsTimer()
    }
  }, 1000)
}

function clearSmsTimer() {
  if (smsTimer) {
    window.clearInterval(smsTimer)
    smsTimer = null
  }

  smsCountdown.value = 0
}

function refreshCaptcha() {
  captchaText.value = captchaText.value === 'ASCYAF' ? 'ascyaf' : 'ASCYAF'
}

function handleSmsLogin() {
  smsFormRef.value.validate((valid) => {
    if (!valid) {
      return
    }

    ElMessage.success('短信登录校验通过')
    dialogVisible.value = true
  })
}

function handlePasswordLogin() {
  passwordFormRef.value.validate((valid) => {
    if (!valid) {
      return
    }

    if (!isAdminAccount(passwordForm.username, passwordForm.password)) {
      ElMessage.error('账号或密码错误')
      return
    }

    // ElMessage.success('密码登录校验通过')
    dialogVisible.value = true
  })
}

function goRegister() {
  router.push('/register')
}

onBeforeUnmount(() => {
  clearSmsTimer()
})
</script>

<style lang="scss" scoped>
.auth-page {
  min-height: 100%;
}

.auth-layout {
  display: flex;
  // grid-template-columns: 1fr 1fr;
  // gap: 24px;
}

.form-card {
  width: 50%;
  padding: 120px;
  // border-radius: 28px;
  display: flex;
  align-items: center;
  background: var(--card-bg);
  border: 1px solid var(--border-color);
  box-shadow: var(--shadow-main);
}

.card-header {
  margin-bottom: 22px;
}

.card-header span {
  font-size: 13px;
  color: var(--primary);
}

.card-header h1 {
  margin: 8px 0 12px;
  font-size: 34px;
}

.card-header p {
  margin: 0;
  line-height: 1.7;
  color: var(--text-secondary);
}

.demo-alert {
  margin-bottom: 18px;
  border-radius: 16px;
}

:deep(.login-mode-tabs .el-tabs__header) {
  margin-bottom: 18px;
}

:deep(.auth-form .el-form-item) {
  margin-bottom: 16px;
}

:deep(.auth-form .el-input__wrapper) {
  min-height: 44px;
  border-radius: 14px;
}

.text-action {
  padding: 0;
  border: 0;
  font-size: 14px;
  white-space: nowrap;
  color: #00C9FF;
  cursor: pointer;
  background: transparent;
}

.text-action:disabled {
  color: #94a3b8;
  cursor: not-allowed;
}

.captcha-field {
  display: flex;
  align-items: stretch;
  gap: 12px;
}

.captcha-field :deep(.el-input) {
  flex: 1;
}

.captcha-box {
  width: 118px;
  min-width: 118px;
  border: 1px solid #dbe3f0;
  border-radius: 12px;
  display: grid;
  place-items: center;
  cursor: pointer;
  background:
    linear-gradient(180deg, #fbf8ff, #f1ecff);
}

.captcha-box span {
  font-size: 22px;
  font-weight: 700;
  letter-spacing: 2px;
  color: #532c88;
  transform: skew(-8deg) rotate(-2deg);
  user-select: none;
}

.submit-btn {
  width: 100%;
  min-height: 46px;
  border-radius: 14px;
  font-size: 16px;
}

.switch-action {
  margin-top: 8px;
  font-size: 14px;
  color: var(--text-secondary);
  display: flex;
  justify-content: center;
}

.switch-action button {
  padding: 0;
  border: 0;
  margin-left: 4px;
  font: inherit;
  color: var(--primary);
  cursor: pointer;
  background: transparent;
}
    .content {
      width:600px;
      // margin: 0 auto;
    }
.visual-panel {
  width: 50%;
  height: calc(100vh - 84px - 70px);
  background: url('../assets/login1.png')no-repeat center center;
  background-size: cover;
}

@media (max-width: 900px) {
  .auth-layout {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 768px) {
  .form-card {
    padding: 22px;
    border-radius: 20px;

  }

  .card-header h1 {
    font-size: 28px;
  }

  .captcha-box {
    width: 100px;
    min-width: 100px;
  }
}
:deep(.el-dialog){
  padding: 36px !important;
}
:deep(.el-dialog__title){
font-weight: bold !important;
}
</style>
